module.exports = __webpack_public_path__ + "static/design06-16c085d391907e70b2381a5b53b6cc2f.jpg";